import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'

function PublicSelfDisclosure() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Public Self Disclosure" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container-fluid">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>Public Self Disclosure</h3>
                                </div>
                                <table className='table table-bordered'>
                                    <thead className='table-light head_red'>
                                        <tr>
                                            <th>S. N.</th>
                                            <th>Heading</th>
                                            <th>Sub-heading</th>
                                            <th>Details/ URL</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>About HEI</td>
                                            <td>About us: Overview</td>
                                            <td><a href="https://mvn.edu.in/#about_container">https://mvn.edu.in/#about_container</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Act and Statutes or MoA</td>
                                            <td><a href="https://admission.mvn.edu.in/wp-content/uploads/2023/07/Statutes.pdf">https://admission.mvn.edu.in/wp-content/uploads/2023/07/Statutes.pdf</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Institutional Development Plan</td>
                                            <td><a href="https://www.mvn.edu.in/iqac1/InstitutionalDevelopmentPlan">https://www.mvn.edu.in/iqac1/InstitutionalDevelopmentPlan</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Constituent Units/ Affiliated Colleges, Affiliating University (in caseof Colleges), Off-campus/Off-shore campus/Learning SupportCentres under ODL mode (Wherever applicable)</td>
                                            <td><a href="javascript:void(0)">Not Applicable</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Accreditation/ Ranking status (NAAC, NBA NIRF)</td>
                                            <td><a href="https://www.mvn.edu.in/iqac1/Affiliation">https://www.mvn.edu.in/iqac1/Affiliation</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Recognition / Approval (2(f), 12B, etc. as applicable)</td>
                                            <td><a href="https://www.mvn.edu.in/iqac1/Accreditations">https://www.mvn.edu.in/iqac1/Accreditations</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Annual Reports</td>
                                            <td><a href="https://www.mvn.edu.in/annual-reports">https://www.mvn.edu.in/annual-reports</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Sponsoring body details, if any</td>
                                            <td><a href="https://www.mvn.edu.in/mvn-societyDisclosure">https://www.mvn.edu.in/mvn-societyDisclosure</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Administration (Profiles with photographs and contact details)</td>
                                            <td>Chancellor</td>
                                            <td><a href="https://www.mvn.edu.in/chancellors-message">https://www.mvn.edu.in/chancellors-message</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Pro Chancellor</td>
                                            <td><a href="javascript:void(0)">NA</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Vice-Chancellor</td>
                                            <td><a href="https://www.mvn.edu.in/vice-chancellor-message">https://www.mvn.edu.in/vice-chancellor-message</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Pro-Vice-Chancellor (wherever applicable)</td>
                                            <td><a href="https://www.mvn.edu.in/pro-vice-chancellor-message">https://www.mvn.edu.in/pro-vice-chancellor-message</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Registrar</td>
                                            <td><a href="https://www.mvn.edu.in/Registrars_message">https://www.mvn.edu.in/Registrars_message</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Principal (wherever applicable)</td>
                                            <td><a href="javascript:void(0)">NA</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Finance Officer</td>
                                            <td><a href="https://www.mvn.edu.in/finance-officer">Sub Page in About </a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Controller of Examination</td>
                                            <td><a href="javascript:void(0)">Available in folder/ Examination / About COE</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Chief Vigilance Officer</td>
                                            <td><a href="https://www.mvn.edu.in/chief-vigilance-officer">https://www.mvn.edu.in/chief-vigilance-officer</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Ombudsperson</td>
                                            <td><a href="https://www.mvn.edu.in/Appointment_of_Ombudsman.pdf">https://www.mvn.edu.in/Appointment_of_Ombudsman.pdf</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Executive Council/Board of Governors by whatever name called, Board of Management, Academic Council, Board of Studies, Finance Committee – composition and members with particulars</td>
                                            <td><a href="https://www.mvn.edu.in/executive-council">https://www.mvn.edu.in/executive-council</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Internal Complaint Committee</td>
                                            <td><a href="https://www.mvn.edu.in/internal-complaint-committee">https://www.mvn.edu.in/internal-complaint-committee</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Academic Leadership (Dean/HoD of Schools/Departments/Centres)</td>
                                            <td>
                                                School of Engineering and Technology<br />
                                                <a href="https://www.mvn.edu.in/school-of-engineering-technology">https://www.mvn.edu.in/school-of-engineering-technology</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                School of Law<br />
                                                <a href="https://www.mvn.edu.in/school-of-engineering-technology">https://www.mvn.edu.in/school-of-engineering-technology</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                School of Allied Health Sciences<br />
                                                <a href="https://www.mvn.edu.in/school-of-allied-health-sciences/home">https://www.mvn.edu.in/school-of-allied-health-sciences/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                School of Pharmaceutical Sciences<br />
                                                <a href="https://www.mvn.edu.in/school-Of-pharmaceutical-sciences/home">https://www.mvn.edu.in/school-Of-pharmaceutical-sciences/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                School of Business Management and Commerce<br />
                                                <a href="https://www.mvn.edu.in/school-of-business-management-and-commerce/home">https://www.mvn.edu.in/school-of-business-management-and-commerce/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>
                                                School of Science and Humanities<br />
                                                <a href="https://www.mvn.edu.in/school-of-arts-science-humanities/home">https://www.mvn.edu.in/school-of-arts-science-humanities/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>Academics</td>
                                            <td>Details of Academic Programs</td>
                                            <td>
                                                Annexure-A (See Attachment)
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Academic Calendar</td>
                                            <td>
                                                <a href="https://www.mvn.edu.in/academic-calendar">https://www.mvn.edu.in/academic-calendar</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Statutes/Ordinances pertaining to Academics/Examinations</td>
                                            <td>
                                                <a href="https://www.mvn.edu.in/examination-scheme">https://www.mvn.edu.in/examination-scheme</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Schools/Departments/ Centres</td>
                                            <td>School of Engineering and Technology<br />
                                                <a href="https://www.mvn.edu.in/school-of-engineering-technology">https://www.mvn.edu.in/school-of-engineering-technology</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Law<br />
                                                <a href="https://www.mvn.edu.in/school-of-law/home">https://www.mvn.edu.in/school-of-law/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Allied Health Sciences<br />
                                                <a href="https://www.mvn.edu.in/school-of-allied-health-sciences/home">https://www.mvn.edu.in/school-of-allied-health-sciences/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Pharmaceutical Sciences<br />
                                                <a href="https://www.mvn.edu.in/school-Of-pharmaceutical-sciences/home">https://www.mvn.edu.in/school-Of-pharmaceutical-sciences/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Business Management and Commerce<br />
                                                <a href="https://www.mvn.edu.in/school-of-business-management-and-commerce/home">https://www.mvn.edu.in/school-of-business-management-and-commerce/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Science and Humanities<br />
                                                <a href="https://www.mvn.edu.in/school-of-arts-science-humanities/home">https://www.mvn.edu.in/school-of-arts-science-humanities/home</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Department/School/Centre-wise faculty/staff details with photographs</td>
                                            <td>Computer Science & Engineering<br />
                                                <a href="https://www.mvn.edu.in/soet-cse/faculties">https://www.mvn.edu.in/soet-cse/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Mechanical Engineering<br />
                                                <a href="https://www.mvn.edu.in/soet-me/faculties">https://www.mvn.edu.in/soet-me/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Civil Engineering<br />
                                                <a href="https://www.mvn.edu.in/soet-civil/faculties">https://www.mvn.edu.in/soet-civil/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Electronic & Communication Engineering  <br />
                                                <a href="https://www.mvn.edu.in/soet-ece/faculties">https://www.mvn.edu.in/soet-ece/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Law  <br />
                                                <a href="https://www.mvn.edu.in/school-of-law/faculties">https://www.mvn.edu.in/school-of-law/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Allied Health Sciences <br />
                                                <a href="https://www.mvn.edu.in/school-of-allied-health-sciences/faculties">https://www.mvn.edu.in/school-of-law/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>SCHOOL OF PHARMACEUTICAL SCIENCES <br />
                                                <a href="https://www.mvn.edu.in/school-Of-pharmaceutical-sciences/faculties">https://www.mvn.edu.in/school-of-law/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>School of Business Management & Commerce <br />
                                                <a href="https://www.mvn.edu.in/school-of-business-management-and-commerce/faculties">https://www.mvn.edu.in/school-of-business-management-and-commerce/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>SCHOOL OF SCIENCE AND HUMANITIES  <br />
                                                <a href="https://www.mvn.edu.in/school-of-arts-science-humanities/faculties">https://www.mvn.edu.in/school-of-arts-science-humanities/faculties</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>List of UGC-recognised ODL/Online programs, if any</td>
                                            <td>Not Applicable</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Internal Quality Assurance Cell (IQAC)</td>
                                            <td><a href="https://www.mvn.edu.in/iqac1">https://www.mvn.edu.in/iqac1</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Library</td>
                                            <td><a href="https://www.mvn.edu.in/library">https://www.mvn.edu.in/library</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Academic collaborations</td>
                                            <td><a href="https://www.mvn.edu.in/academic-collaborations">https://www.mvn.edu.in/academic-collaborations</a></td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Admissions</td>
                                            <td>Prospectus (including fee)</td>
                                            <td><a href="https://www.mvn.edu.in/prospectus">https://www.mvn.edu.in/prospectus</a></td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Admissions Fee</td>
                                            <td>Prospectus (including fee structure for various programs)</td>
                                            <td><a href="https://www.mvn.edu.in/prospectus">https://www.mvn.edu.in/prospectus</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Admission process and guidelines</td>
                                            <td><a href="https://www.mvn.edu.in/application-policy">https://www.mvn.edu.in/application-policy</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Fee refund policy</td>
                                            <td><a href="https://www.mvn.edu.in/fee-structure">https://www.mvn.edu.in/fee-structure</a></td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Research</td>
                                            <td>Research and Development Cell (including Research and Consultancy Projects, Foreign Collaboration Industry Collaborations)</td>
                                            <td><a href="https://www.mvn.edu.in/research_development/home">https://www.mvn.edu.in/research_development/home</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Incubation Centre/Start-ups/Entrepreneurship Cell</td>
                                            <td><a href="https://www.mvn.edu.in/incubation-centre">https://www.mvn.edu.in/incubation-centre</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Central facilities</td>
                                            <td><a href="https://www.mvn.edu.in/central-facilities">https://www.mvn.edu.in/central-facilities</a></td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>Student Life</td>
                                            <td>Sports facilities</td>
                                            <td><a href="https://www.mvn.edu.in/life-at-mvn">https://www.mvn.edu.in/life-at-mvn</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>NCC/NSS</td>
                                            <td><a href="https://www.mvn.edu.in/ncc">https://www.mvn.edu.in/ncc</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Hostel details (wherever applicable)</td>
                                            <td><a href="https://www.mvn.edu.in/hostel">https://www.mvn.edu.in/hostel</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Placement Cell and its activities</td>
                                            <td><a href="https://www.mvn.edu.in/the-corporate-resource-centre">https://www.mvn.edu.in/the-corporate-resource-centre</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Details of Student Grievance Redressal Committee (SGRC) and Ombudsperson</td>
                                            <td><a href="https://www.mvn.edu.in/assets/img/Appointment_of_Ombudsman.pdf">https://www.mvn.edu.in/assets/img/Appointment_of_Ombudsman.pdf</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Health facilities</td>
                                            <td><a href="https://www.mvn.edu.in/opd-clinic">https://www.mvn.edu.in/opd-clinic</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Internal Complaint Committee</td>
                                            <td><a href="https://www.mvn.edu.in/internal-complaint-committee">https://www.mvn.edu.in/internal-complaint-committee</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Anti-Ragging Cell</td>
                                            <td><a href="https://www.mvn.edu.in/antiraggingcommittees">https://www.mvn.edu.in/antiraggingcommittees</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Equal Opportunity Cell</td>
                                            <td><a href="https://www.mvn.edu.in/equalopportunitycell">https://www.mvn.edu.in/equalopportunitycell</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Socio-Economically Disadvantaged Groups Cell (SEDG)</td>
                                            <td><a href="https://www.mvn.edu.in/socioeconomically">https://www.mvn.edu.in/socioeconomically</a></td>
                                        </tr>
                                        <tr>
                                            <td>&NBSP;</td>
                                            <td>&nbsp;</td>
                                            <td>Facilities for differently abled (e.g., barrier-free environment)</td>
                                            <td><a href="https://www.mvn.edu.in/DifferentlyAbled">https://www.mvn.edu.in/DifferentlyAbled</a></td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>Alumni</td>
                                            <td>Alumni Association with details</td>
                                            <td><a href="https://www.mvn.edu.in/alumni">https://www.mvn.edu.in/alumni</a></td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>Information </td>
                                            <td>RTI: Details of Central Public </td>
                                            <td><a href="https://www.mvn.edu.in/rti">https://www.mvn.edu.in/rti</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>Corner </td>
                                            <td>Information Officer (CPIO) and Appellate Authority (wherever applicable)</td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Circulars and Notices</td>
                                            <td><a href="https://mvn.edu.in/#press_release">https://mvn.edu.in/#press_release</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Announcements</td>
                                            <td><a href="https://mvn.edu.in/#notification">https://mvn.edu.in/#notification</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Newsletters</td>
                                            <td><a href="https://www.mvn.edu.in/newsletters">https://www.mvn.edu.in/newsletters</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>News, Recent events & Achievements</td>
                                            <td><a href="https://mvn.edu.in/#upcoming_events">https://mvn.edu.in/#upcoming_events</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Job openings</td>
                                            <td><a href="https://www.mvn.edu.in/jobs">https://www.mvn.edu.in/jobs</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Reservation Roster (wherever applicable)</td>
                                            <td><a href="https://nhmharyana.gov.in/WriteReadData/Guidelines/NHMInstructions/Reservationpolicy.pdf">Reservationpolicy</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Study in India</td>
                                            <td><a href="https://www.studyinindia.gov.in/courses/exploreallcoruses">https://www.studyinindia.gov.in/courses/exploreallcoruses</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp; </td>
                                            <td>Admission procedure and facilities provided to International Students</td>
                                            <td><a href="https://www.mvn.edu.in/application-policy">https://www.mvn.edu.in/application-policy</a></td>
                                        </tr>
                                        <tr>
                                            <td>9</td>
                                            <td>Picture Gallery</td>
                                            <td>Picture Gallery</td>
                                            <td><a href="https://mvn.edu.in/#home_gallery">https://mvn.edu.in/#home_gallery</a></td>
                                        </tr>
                                        <tr>
                                            <td>10</td>
                                            <td>Contact Us</td>
                                            <td>Details with Phone Number, Official Email ID and Address, Location map</td>
                                            <td><a href="https://www.mvn.edu.in/contactus">https://www.mvn.edu.in/contactus</a></td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                            <td>&nbsp;</td>
                                            <td>Telephone Directory</td>
                                            <td>NA</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PublicSelfDisclosure